import { useEffect, useState } from 'react';

import useStore from '../../store';
import { IUser } from '../ts/user';

const useBookingGuests = (bookingId: string | null): IUser[] => {
  const [guests, setGuests] = useState<IUser[]>([]);
  const getBookingGuests = useStore(state => state.getGuests);

  useEffect(() => {
    if (bookingId) {
      const getGuests = async () => {
        try {
          const fetchedGuests = await getBookingGuests(bookingId);
          if (fetchedGuests !== undefined) {
            setGuests(fetchedGuests);
          }
        } catch (err) {
          console.error(err);
        }
      };

      getGuests();
    }
  }, [bookingId]);

  return guests;
};

export default useBookingGuests;
